module.exports = __webpack_public_path__ + "media/click.34ea45a6.mp3";